import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function AppHomePage() {
  const nav = useNavigate();
  const token = localStorage.getItem("access") || "";
  const role = (localStorage.getItem("me.role") || "").toUpperCase();

  const [appWallet, setAppWallet] = useState(null);
  const [appLatestOrder, setAppLatestOrder] = useState(null);
  const [appNotifications, setAppNotifications] = useState([]);
  const [appSponsors, setAppSponsors] = useState([]);
  const [activeSponsorIndex, setActiveSponsorIndex] = useState(0);

  const [walletWelcomePromo, setWalletWelcomePromo] = useState(null);
  const [showWalletWelcome, setShowWalletWelcome] = useState(false);

  const mediaUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http") || url.startsWith("blob:")) return url;
    return `${API_URL}${url.startsWith("/") ? url : `/${url}`}`;
  };

  useEffect(() => {
    if (!token) {
      const loadGuestSponsors = async () => {
        try {
          const sponsorRes = await fetch(`${API_URL}/api/app/sponsors/visible/`);
          const sponsorData = sponsorRes.ok ? await sponsorRes.json() : {};
          setAppSponsors(Array.isArray(sponsorData.sponsors) ? sponsorData.sponsors : []);
        } catch {
          setAppSponsors([]);
        }
      };

      loadGuestSponsors();
      const timer = setInterval(loadGuestSponsors, 20000);
      return () => clearInterval(timer);
    }

    if (role !== "CLIENTE") return;

    const load = async () => {
      try {
        const [walletRes, ordersRes, notifRes, sponsorRes, walletPromoRes] = await Promise.all([
          authFetch(`${API_URL}/api/app/wallet/`),
          authFetch(`${API_URL}/api/app/ordini/storico/`),
          authFetch(`${API_URL}/api/app/notifications/`),
          authFetch(`${API_URL}/api/app/sponsors/visible/`),
          authFetch(`${API_URL}/api/wallet/active-campaign/`),
        ]);

        setAppWallet(walletRes.ok ? await walletRes.json() : null);

        const ordersData = ordersRes.ok ? await ordersRes.json() : [];
        const orders = Array.isArray(ordersData) ? ordersData : (ordersData?.results || []);
        setAppLatestOrder(
          orders.find((o) => String(o.app_status || o.status || "").toUpperCase() !== "RITIRATO") || null
        );

        const notifData = notifRes.ok ? await notifRes.json() : [];
        setAppNotifications(Array.isArray(notifData) ? notifData : []);

        const sponsorData = sponsorRes.ok ? await sponsorRes.json() : {};
        setAppSponsors(Array.isArray(sponsorData.sponsors) ? sponsorData.sponsors : []);

        const walletPromoData = walletPromoRes.ok ? await walletPromoRes.json() : null;

        setWalletWelcomePromo(walletPromoData);

        if (
          walletPromoData?.show === true &&
          walletPromoData?.eligible !== false &&
          !sessionStorage.getItem("dzr_wallet_welcome_dismissed")
        ) {
          setShowWalletWelcome(true);
        } else {
          setShowWalletWelcome(false);
        }
      } catch {
        setAppWallet(null);
        setAppLatestOrder(null);
        setAppNotifications([]);
        setAppSponsors([]);
        setWalletWelcomePromo(null);
        setShowWalletWelcome(false);
      }
    };

    load();
    const timer = setInterval(load, 20000);
    return () => clearInterval(timer);
  }, [token, role]);

  useEffect(() => {
    if (!appSponsors.length) return;
    const timer = setInterval(() => {
      setActiveSponsorIndex((prev) => (prev + 1) % appSponsors.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [appSponsors.length]);

  const activeSponsor = appSponsors.length ? appSponsors[activeSponsorIndex % appSponsors.length] : null;

  const closeWalletWelcome = () => {
    sessionStorage.setItem("dzr_wallet_welcome_dismissed", "1");
    setShowWalletWelcome(false);
  };

  const goToWalletFromWelcome = () => {
    sessionStorage.setItem("dzr_wallet_welcome_dismissed", "1");
    setShowWalletWelcome(false);
    nav("/app/wallet");
  };

  const menuBoxes = [
    { icon: "🍷", title: "Catalogo prodotti", subtitle: "Scegli vini, alimentari e prodotti disponibili.", link: "/app/products" },
    { icon: "🔥", title: "Offerte", subtitle: "Scopri promozioni, novità e occasioni attive.", link: "/app/offers" },
    { icon: "🛒", title: "Carrello", subtitle: "Controlla il tuo ordine prima del checkout.", link: "/app/carrello" },
    { icon: "💳", title: "Wallet / Ricarica", subtitle: "Saldo, ricariche online e credito disponibile.", link: "/app/wallet" },
    { icon: "📦", title: "I miei ordini", subtitle: "Segui stato, ritiro e storico dei tuoi ordini.", link: "/app/ordini" },
    { icon: "🎁", title: "Punti e premi", subtitle: "Controlla punti raccolti e premi disponibili.", link: "/app/punti" },
    { icon: "🧪", title: "Centro Assistenza", subtitle: "Apri un ticket, invia screenshot e consulta comunicazioni e assistenza.", link: "/app/beta" },
    { icon: "👤", title: "Account e sicurezza", subtitle: "Profilo, password, privacy e gestione dell'account.", link: "/app/account" },
  ];

  return (
    <div className="container py-3" style={{ maxWidth: 760 }}>
      {showWalletWelcome && walletWelcomePromo?.campaign && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3"
          style={{
            zIndex: 9999,
            background: "rgba(20, 10, 12, 0.72)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div
            className="card border-0 shadow-lg rounded-5 overflow-hidden"
            style={{ width: "100%", maxWidth: 460 }}
          >
            <div
              className="card-body p-4 text-center"
              style={{
                background: "linear-gradient(135deg, #fffaf5 0%, #ffffff 100%)",
              }}
            >
              <div style={{ fontSize: 54 }}>🎁</div>

              <div
                className="small text-uppercase fw-bold mt-2"
                style={{ letterSpacing: 1.4, color: "#8b1e2d" }}
              >
                Bonus di benvenuto
              </div>

              <h2 className="fw-bold mt-2 mb-3">
                Hai un regalo riservato!
              </h2>

              <div className="text-muted mb-2">
                Effettua la tua prima ricarica Wallet e ricevi subito
              </div>

              <div
                className="fw-bold mb-2"
                style={{ fontSize: 42, color: "#198754" }}
              >
                +€ {Number(walletWelcomePromo.campaign.bonus_fixed_amount || 0).toFixed(2)}
              </div>

              <div className="fw-semibold mb-3">
                con una ricarica minima di €{" "}
                {Number(walletWelcomePromo.campaign.min_recharge_amount || 0).toFixed(2)}
              </div>

              <div className="text-muted small mb-4">
                Il bonus verrà accreditato automaticamente ed è valido una sola volta sulla prima ricarica.
              </div>

              <div className="d-grid gap-2">
                <button
                  type="button"
                  className="btn btn-success btn-lg rounded-pill fw-bold"
                  onClick={goToWalletFromWelcome}
                >
                  Ricarica adesso
                </button>

                <button
                  type="button"
                  className="btn btn-light rounded-pill fw-semibold"
                  onClick={closeWalletWelcome}
                >
                  Più tardi
                </button>
              </div>

              <div className="small text-muted mt-4">
                Il Wallet ti permette di pagare più velocemente, ricevere bonus esclusivi e partecipare alle promozioni dedicate.
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="mb-4" style={{ marginTop: -8 }}>
        <div
          className="rounded-5 shadow-lg overflow-hidden"
          style={{
            background: "radial-gradient(circle at 20% 0%, #8b1e2d 0%, #5b0f1b 45%, #211014 100%)",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.12)"
          }}
        >
          <div className="p-4 pb-3 text-center">
            <img
              src={mediaUrl("/static/media/dzr-logo.1a93b31f68fe43a4b6d8.png")}
              alt="Dallo Zio Roby"
              style={{ width: 118, height: 118, objectFit: "contain", filter: "drop-shadow(0 14px 26px rgba(0,0,0,0.35))" }}
            />
            <div className="mt-2 small text-uppercase" style={{ letterSpacing: 1.4, opacity: 0.75 }}>App Clienti</div>
            <h1 className="fw-bold mb-1" style={{ fontSize: 30 }}>Dallo Zio Roby</h1>
            <div className="mx-auto" style={{ maxWidth: 320, opacity: 0.84 }}>
              Ordina il tuo vino, ricarica il wallet e segui punti e promozioni.
            </div>
          </div>

          <div className="px-3 pb-4">
            <div className="rounded-4 p-3 mb-3 d-flex justify-content-between align-items-center" style={{ background: "rgba(255,255,255,0.12)", backdropFilter: "blur(8px)" }}>
              <div>
                <div className="small" style={{ opacity: 0.75 }}>Credito disponibile</div>
                <div className="fw-bold" style={{ fontSize: 30 }}>€ {Number(appWallet?.total_balance || 0).toFixed(2)}</div>
              </div>
              <div style={{ fontSize: 34 }}>💳</div>
            </div>

            <div className="rounded-4 p-3 mb-3 d-flex justify-content-between align-items-center" role="button" onClick={() => nav("/app/notifications")} style={{ background: "rgba(255,255,255,0.18)", backdropFilter: "blur(8px)", cursor: "pointer" }}>
              <div>
                <div className="small" style={{ opacity: 0.75 }}>Notifiche</div>
                <div className="fw-bold" style={{ fontSize: 18 }}>
                  {appNotifications.filter((n) => !n.is_read).length > 0
                    ? `${appNotifications.filter((n) => !n.is_read).length} notifica da leggere`
                    : "Nessuna nuova notifica"}
                </div>
                <div className="small" style={{ opacity: 0.75 }}>Tocca per aprire le notifiche →</div>
              </div>
              <div style={{ fontSize: 34 }}>🔔</div>
            </div>

            <div className="d-grid gap-2">
              <button type="button" className="btn btn-light btn-lg rounded-pill fw-bold py-3" onClick={() => nav("/app/products")}>🍷 Ordina ora</button>
              <button type="button" className="btn btn-outline-light rounded-pill fw-bold py-3" onClick={() => nav("/app/wallet")}>💳 Ricarica wallet</button>
              {!token && (
                <button type="button" className="btn btn-outline-light rounded-pill fw-bold py-3" onClick={() => nav("/app/login")}>
                  Accedi o registrati
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {appLatestOrder && (() => {
        const rawStatus = String(
          appLatestOrder.app_status || appLatestOrder.status || ""
        ).toUpperCase();

        let orderLabel = "Ordine inviato";
        let orderIcon = "📩";

        if (rawStatus === "IN_PREPARAZIONE") {
          orderLabel = "In preparazione";
          orderIcon = "⏳";
        } else if (rawStatus === "PRONTO_RITIRO") {
          orderLabel = "Pronto per il ritiro";
          orderIcon = "📦";
        } else if (rawStatus === "RITIRATO") {
          orderLabel = "Ritirato";
          orderIcon = "✅";
        }

        return (
          <div
            className="card border-0 rounded-5 shadow-sm mb-3 overflow-hidden"
            role="button"
            onClick={() => nav("/app/ordini")}
            style={{ background: "#fff8f1", cursor: "pointer" }}
          >
            <div className="card-body p-3 d-flex justify-content-between align-items-center gap-3">
              <div className="flex-grow-1">
                <div className="small text-muted">
                  Ordine in corso · #{appLatestOrder.id}
                </div>

                <div
                  className="fw-bold mt-1"
                  style={{ color: "#5b0f1b", fontSize: 24 }}
                >
                  {orderIcon} {orderLabel}
                </div>

                <div className="text-muted mt-1">
                  Tocca per seguire l’avanzamento →
                </div>
              </div>

              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: 58,
                  height: 58,
                  borderRadius: "50%",
                  background: "#f4e8e8",
                  fontSize: 30,
                }}
              >
                {orderIcon}
              </div>
            </div>
          </div>
        );
      })()}

      <div className="row mt-4 g-3">
        {menuBoxes.map((b) => (
          <div className="col-12" key={b.link}>
            <div className="card border-0 shadow-sm rounded-5 overflow-hidden" role="button" onClick={() => nav(b.link)} style={{ cursor: "pointer", background: "#fffdf9" }}>
              <div className="card-body p-3 d-flex align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-center shadow-sm" style={{ width: 76, height: 76, borderRadius: 22, background: "linear-gradient(135deg, #8b1e2d 0%, #5b0f1b 100%)", fontSize: 34, flexShrink: 0 }}>
                  {b.icon}
                </div>
                <div className="flex-grow-1">
                  <div className="fw-bold" style={{ fontSize: 24 }}>{b.title}</div>
                  <div className="text-muted" style={{ fontSize: 18, lineHeight: 1.2 }}>{b.subtitle}</div>
                </div>
                <div className="d-flex align-items-center justify-content-center" style={{ width: 54, height: 54, borderRadius: "50%", background: "#f4e8e8", color: "#8b1e2d", fontSize: 34, fontWeight: 900 }}>›</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card border-0 shadow-sm rounded-4 my-4 overflow-hidden">
        <div className="card-body text-center p-4" style={{ background: "linear-gradient(135deg, #1f1f1f 0%, #2f2f2f 100%)", color: "#fff" }}>
          <div className="small text-uppercase opacity-75 mb-2">Sponsor Partner</div>
          {activeSponsor ? (
            <div
              role={activeSponsor.website_url ? "button" : undefined}
              onClick={async () => {
                if (!activeSponsor.website_url) return;

                const url = activeSponsor.website_url.startsWith("http")
                  ? activeSponsor.website_url
                  : `https://${activeSponsor.website_url}`;

                fetch(`${API_URL}/api/app/sponsors/${activeSponsor.id}/click/`, {
                  method: "POST",
                  keepalive: true,
                  credentials: "omit",
                })
                  .then(async (res) => {
                    if (!res.ok) {
                      throw new Error(`HTTP ${res.status}`);
                    }
                    const body = await res.json();
                    console.log("CLICK SPONSOR REGISTRATO:", body);
                  })
                  .catch((error) => {
                    console.error("CLICK SPONSOR NON REGISTRATO:", error);
                  });

                window.open(url, "_blank", "noopener,noreferrer");
              }}
              style={{ cursor: activeSponsor.website_url ? "pointer" : "default" }}
            >
              {activeSponsor.image && (
                <img src={mediaUrl(activeSponsor.image)} alt={activeSponsor.name} className="img-fluid rounded-4 bg-white p-2 mb-3" style={{ maxHeight: 130, objectFit: "contain" }} />
              )}
              <div className="fw-bold fs-4 mb-2">{activeSponsor.name}</div>
              <div className="opacity-75 mb-3">{activeSponsor.description || "Partner ufficiale Dallo Zio Roby."}</div>
              <button
                type="button"
                className="btn btn-outline-light rounded-pill px-4"
              >
                {activeSponsor.button_label || "Visita"}
              </button>
            </div>
          ) : (
            <>
              <div className="fw-bold fs-4 mb-2">Qui potrà comparire il tuo brand</div>
              <div className="opacity-75 mb-3">Spazio dedicato ai partner e sponsor ufficiali Dallo Zio Roby.</div>
              <button type="button" className="btn btn-outline-light rounded-pill px-4">Diventa Sponsor</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
